import { SvrConn } from "../utils/axios/index";
/**
 *
 */
const getPantallaAll = async () => {
    let res = {};
    try {
      res = await SvrConn.get("/api/projector/getpantallaall");
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 *  Buscar las pantallas por area sin importar el estado
 */
const getPantallaAllxArea = async (AreaId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/projector/getpantallaallarea",{AreaId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
   * 
  */
const setBloqueaPantalla = async (areaId, pantallaId, TagId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/projector/setbloqueapantalla", { areaId, pantallaId,TagId });
    } catch (Error) {
      res = Error;
    }
    return res;
  };
/**
 * 
 */
const setDesvinculaPantalla = async (areaId, pantallaId) => {
  let res = {};
  try {
    res = await SvrConn.post("/api/projector/setdesvinculapantalla", { areaId, pantallaId });
  } catch (Error) {
    res = Error;
  }
  return res;
};
/**
 * 
 */
const getPantallaInt = async (AreaId, PantallaId) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/projector/getpantallaint",{AreaId, PantallaId});
    } catch (Error) {
      res = Error;
    }
    return res;
  };
  /**
   * 
   */
  const actualizaPantalla = async (data) => {
    let res = {};
    try {
      res = await SvrConn.post("/api/projector/setactualizapantalla", data);
    } catch (Error) {
      res = Error;
    }
    return res;
  };

  export {
    getPantallaAll,
    getPantallaAllxArea,
    setDesvinculaPantalla,
    setBloqueaPantalla,
    getPantallaInt,
    actualizaPantalla
  };
  